import CustomLabel from "components/Common/CustomLabel"
import { getLocalizedName } from "components/Common/Utils"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap"
import { changeJobTitle } from "store/actions/interviewsAction"
import { jobPromoteSuggestion } from "store/actions/practicalTrainingAction"
import { showAlert } from "store/reducers/alertReducer"

const ChangeJobTitleModal = ({
  isOpen,
  toggle,
  jobTitlesList,
  training_uuid,
  user_uuid,
  updateJobTitle,
  trigger,
  suggestedJobTitle,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(false)
  const [selectedJobId, setSelectedJobId] = useState("")
  const [reason, setReason] = useState("")

  const handleSuggestJobTitleChange = () => {
    if (!reason)
      return dispatch(
        showAlert({ text: t("Reason is required"), type: "error" })
      )

    let payload = {
      reason,
      training_uuid,
      user_uuid,
      suggested_job_title_id: selectedJobId,
    }
    setIsLoading(true)
    dispatch(jobPromoteSuggestion(payload))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          toggle()
          setIsLoading(false)
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
          setIsLoading(false)
        }
      })
      .catch(err => {})
  }

  const handleJobTitleChange = () => {
    const payload = {
      job_applicant_assessments_uuid: user_uuid,
      job_title_id: selectedJobId,
    }
    setIsLoading(true)
    dispatch(changeJobTitle(payload))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          setIsLoading(false)

          dispatch(showAlert({ text: message, type: "success" }))
          toggle()
          trigger()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
          setIsLoading(false)
        }
      })
      .catch(error => {})
  }

  useEffect(() => {
    if (updateJobTitle && suggestedJobTitle) {
      setSelectedJobId(
        jobTitlesList.find(job => job.name === suggestedJobTitle)?.id
      )
    }
  }, [updateJobTitle])

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle}>{t("Promote Job Title")}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="jobTitle">{t("Select Job Title")}</Label>
          <Input
            type="select"
            id="jobTitle"
            value={selectedJobId || ""}
            onChange={e => setSelectedJobId(e.target.value)}
          >
            <option value="" disabled>
              -- {t("Select Job Title")} --
            </option>
            {jobTitlesList.map(job => (
              <option key={job.id} value={job.id}>
                {getLocalizedName(job, language)}
              </option>
            ))}
          </Input>
        </FormGroup>
        {!updateJobTitle && (
          <FormGroup>
            <CustomLabel isRequired label={t("Reason")} />
            <Input
              type="textarea"
              name="reason"
              id="reason"
              value={reason}
              onChange={e => setReason(e.target.value)}
              placeholder={t("Enter your reason here")}
            />
          </FormGroup>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          {t("Close")}
        </Button>
        <Button
          color="primary"
          onClick={
            updateJobTitle ? handleJobTitleChange : handleSuggestJobTitleChange
          }
          disabled={!selectedJobId || isLoading}
        >
          {updateJobTitle ? t("Suggest") : t("Promote")}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ChangeJobTitleModal
